module.exports = __webpack_public_path__ + "img/icon-email.c38fb33f.svg";